<template>
    <section class="content">
        <div class="container-fluid">
                <div class="card">
                    <div class="fn-header">
                        บันทึกแพคเกจ 
                    </div>
                    <div class="body table-responsive" style="width:100%" >
                        <div class="preloader pl-size-xl"  v-if="loading == true">
                            <div class="spinner-layer pl-orange">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                    <div v-else>
                        <div class="row">
                            
                         
                            <div class="col-sm-12" style="display: flex;">
                                <input type="text" class="t-textbox" v-model="key" placeholder="กรอกชื่อหรือราคาเพื่อค้นหา" style="margin-right:15px">
                               
                                <button type="button" class="btn btn-default waves-effect" @click="search()" alt="ค้นหา">
                                    <i class="material-icons">search</i>
                                </button>
                                <button type="button" class="btn btn-default waves-effect" style="margin-left: 5px;" @click="reset()">
                                    <i class="material-icons">refresh</i>
                                </button>
                            </div>
                           
                        </div>
                        
                        <div class="row">
                            <div class="col-md-4"  v-for="(item,index) in items" :key="'package-btn-' + index"  style="display: flex;justify-content: center;margin-top: 15px;">
                                <div style="width: 48%;">
                                <button type="button" class="btn btn-package waves-effect btn-search"  @click="addRecord(item[0])">
                                    <div class="title-package-price">{{  item[0].price }} บาท</div>
                                    <div class="title-package-name">{{  item[0].package_name }}</div>
                                </button> 
                                </div>
                                <div style="width: 4%;"></div>
                                <div style="width: 48%;">
                                    <button type="button" class="btn btn-package  waves-effect btn-search"  @click="addRecord(item[1])"  v-if="item && item[1]">
                                        <div class="title-package-price">{{  item[1].price }} บาท</div>
                                        <div class="title-package-name">{{  item[1].package_name }}</div>
                                    </button> 
                              </div>
                            </div>
                        </div>
                        <div class="row" style="padding-left: 10px;margin-top: 15px;">
                            <Paginate
                            :page-count=pages
                            :page-range="5"
                            :click-handler="search"
                            :prev-text="'Prev'"
                            :next-text="'Next'"
                            :container-class="'fn-pagination'"
                        />
                        </div>
                    </div>

                       

                        
                    </div>
                </div>
        </div>
        <div class="modal fade" id="package-record-modal" tabindex="-1" role="dialog" >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header modal-close" @click="modalClose()">
                        <i class="material-icons">close</i>
                        
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 100px;">
                   
                    
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label" style="text-align: left;">
                            <div>แพคเกจ </div>
                        </div>
                        <div class="col-sm-10" style="text-align: left;">
                             <div style="margin-top: 5px;"><span style="color:#FF5722;font-weight: bold;">{{  package_name }}</span> / <span style="color:#4CAF50;font-weight: bold;"> {{ price }}</span> บาท </div>
                        </div>
                    </div>


                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label" style="text-align: left;">
                            <div>จำนวนสั่งซื้อ</div>
                        </div>
                        <div class="col-sm-10">
                            <input id="package-number" type="number"  class="form-control" v-model="record.amount" placeholder="">
                        </div>
                    </div>
                    
            
                </div>
                <div class="modal-footer" style="background:white;margin-bottom: 20px;">
                    <div class="row" style="margin-top: 15px;margin-bottom: 20px;">
                        <div class="col-sm-12" style="margin: auto;">
                           
                            <button type="button" class="btn btn-primary waves-effect" style="width: 100%; height: 50px;" @click="handleSave()">
                                <i class="material-icons">save</i>
                                <span>บันทึก</span>
                            </button>
                        </div>
                    </div>
                  
                    
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { PackageService, RecordService } from '../../service'
import moment from 'moment'
import alertBox from '../../classes/alertBox'
import uniqid from 'uniqid';
import Paginate from 'vuejs-paginate'

export default {
    name : "RecordCreate",
    components: {
        Paginate
    },
    data(){
        return {
            user:JSON.parse(localStorage.getItem('user')),
            page : 1,
            perpage : 500,
            total : 0,
            total_page:0,
            pages : 1,
            block_set : 5,
            block_index : 0,
            blocks : [],
            items: [],
            record: {},
            loading : false,
            modal_name:"#package-record-modal",
            current_date:"",
            date:localStorage.getItem('date'),
            package_name:"",
            price:0,
            key:""
        }
    },
   
    async created() {
        
        this.current_date = moment(this.date).format('DD/MM/YYYY')
        this.search()
    },
    mounted(){

    },
    methods: {
        uniq(){
            return uniqid()
        },
        async search(){
            this.loading = true
            
            let response = await PackageService.searchList(this.key,this.page,this.perpage)
            
            if(response.status)
            {
                let{page,perpage,total,pages,data} = response.result
                this.page = page
                this.perpage = perpage
                this.total = total
                this.pages = pages
                this.items = this.splitColumn(data,2)
               
               
            }
            this.loading = false
        },
        reset(){
            this.key = ""
            this.search()
        },
        addRecord(item){
            this.record ={
                package_id : item.package_id,
                price:0,
                amount:"",
                create_datetime:"",
                update_datetime:"",
                create_by: this.user.id
            }
            this.package_name = item.package_name
            this.price = item.price
            $(this.modal_name).modal('show')
            setTimeout(() => {
                $('#package-number').focus()
            }, 500);
           
        },
        modalClose(){
            $(this.modal_name).modal('hide')
        },
        async handleSave(){
            if(!this.validate()){
                return false
            }

            try{
            
                let response = await RecordService.create(this.record)
                
                if(response.status){
                    alertBox.success('save success')
                    $(this.modal_name).modal('hide')
                   this.search()
                }
                else{
                    alertBox.error("Error, " + response.error)
                }
            }
            catch(error){
                alertBox.error("Error, " + error)
            } 
        },
        validate(){
           
            if(!this.record.amount){
                alertBox.error("กรุณากรอกจำนวนสั่งซื้อ")
                    return false
            }
            
            return true
        },
        splitColumn(arr, size){
            var index = 0;
            var arrayLength = arr.length;
            var tempArray = [];
    
            for (index = 0; index < arrayLength; index += size) {
                var chunk = arr.slice(index, index + size);
                tempArray.push(chunk);
            }

            return tempArray;
        },
       
    },
    filters:{
        comma(value) {
            return helper.WithComma(value)
        },
        date(value){
            if(!value) return ""

            return  moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>

<style scoped>
    
    .link{
        font-weight: bold;
    }
    .p-title{
        text-align: left;
        font-weight: bold;
        margin-bottom: 15px;
    }
    .btn-package{
        height: 80px;
       
    }
    .btn-package2{
        width: 80%;
        height: 60px;
    }
   

   .title-package-price{
        font-size: 20px;
        font-weight: bold;
        color: #4CAF50;
   }
   .title-package-name{
        font-size: 18px;
        color: #FF5722;
        font-weight: 700;
   }
   .modal-close{
    cursor: pointer;
    padding: 10px;
    font-size: 20px;
    font-weight: bold;
    text-align: right;
    margin-right: 7px;
   }

</style>


// WEBPACK FOOTER //
// src/components/Record/RecordCreate.vue